import React, { Component } from 'react'
import '../../stylesheets/kiley.sass'


export default class Kiley extends Component {
  render() {
    return (
      <div className='kiley-bg'>
        <div className='main-content'>
          <h1>Kiley</h1>
          <p>Coming soon!</p>
        </div>
      </div>
    )
  }
}
